import { Deserializable } from "../shared/models/deserializable.model";
import { Injectable } from '@angular/core';
import { WorkItem } from './work-item';
import { Contact } from './contact';
import { Business } from './business';
import { Property } from './property';
import { Payment } from './payment';
import { Job } from './job';
import { EmailSendLog } from './email-send-log';
import { Gallery } from './gallery';

import { map } from 'rxjs/operators';

export class Invoice implements Deserializable {
   accountId: number;
   id: number;
   description: string;
   description_position: string;
   publicId: string;
   invoice_number: string;
   invoice_date: string;
   isSent: boolean;
   isPaid: boolean;
   createdAt: Date;
   updatedAt: Date;
   chargesTotal: number;
   balance: number;
   contactId: number;
   propertyId: number;
   businessId: number;
   jobId: number;
   galleryId: number;
   currency: string;
   WorkItems: WorkItem[];
   Payments: Payment[];
   EmailSendLogs: EmailSendLog[];
   Contact: Contact;
   Property: Property;
   Business: Business;
   Job: Job;
   Gallery: Gallery;
   total: any;
   invoiceWebLink: string;

   constructor() {
      this.isSent = false;
      this.isPaid = false;
      this.WorkItems = [];
      this.Payments = [];
   }

   deserialize(input: any) {
   	Object.assign(this, input);

      // Map Work Items to Model
      if (input.WorkItems && input.WorkItems.length > 0) {
         this.WorkItems = input.WorkItems.map((workitem: any) => new WorkItem().deserialize(workitem));
      }
      else {
         this.WorkItems = [];
      }

      // Map Payments to Model
      if (input.Payments && input.Payments.length > 0) {
         this.Payments = input.Payments.map((payment: any) => new Payment().deserialize(payment));
      }
      else {
         this.Payments = [];
      }

      // Map Contact to Model
      if (input.Contact)
         this.Contact = new Contact().deserialize(input.Contact);

      // Map Property to Model
      if (input.Property)
         this.Property = new Property().deserialize(input.Property);

      // Map Business to Model
      if (input.Business)
         this.Business = new Business().deserialize(input.Business);

      // Map Job to Model
      if (input.Job)
         this.Job = new Job().deserialize(input.Job);

      // Map Gallery to Model
      if (input.Gallery)
         this.Gallery = new Gallery().deserialize(input.Gallery);

      // Created & updated
      this.createdAt = new Date(Date.parse(input.createdAt));
      this.updatedAt = new Date(Date.parse(input.updatedAt));
      
      return this;
  }

   // Total Preview method for the model (API's total is the total parameter of the model)
   get getTotal(): any {

     var total = 0;
     var totalTax = 0;
     var totalIncTax = 0;
     var balance = 0;
     var payments = 0;

     if (this.WorkItems && this.WorkItems.length > 0) {
        
        // Start running some calcaulations for Work Items
         for (var i = 0 ; i < this.WorkItems.length; i++) {
           var subTotal = this.WorkItems[i].quantity * this.WorkItems[i].rate*0.01;
           var subTax = subTotal * (this.WorkItems[i].taxRate / 100);

           // Add to running total
           total += subTotal;

           if (this.WorkItems[i].hasTax) {
              totalTax += subTax;
              totalIncTax += subTotal + subTax;
           }
           else {
              totalIncTax += subTotal;
           }

        }

         // Assess payments
         if (this.Payments && this.Payments.length > 0) {
            for (var i = 0 ; i < this.Payments.length; i++) {
               payments += (this.Payments[i].amount * 0.01);
            }
         }

         // Calculate balance
         balance = totalIncTax - payments;
     }

     return {
         total: total.toFixed(2),
         totalTax: totalTax.toFixed(2),
         totalIncTax: totalIncTax.toFixed(2),
         balance: balance.toFixed(2),
         payments: payments.toFixed(2)
     }
   }

  updateWorkItem(id: number, updatedWorkItem: WorkItem): void {
     // find the Work Item in this.workItems using the ID and update it
     const index = this.WorkItems.findIndex(item => item.id === id);
     if (index !== -1) {
        this.WorkItems[index] = updatedWorkItem;
     }
  }

  updateWorkItemByIndex(index: number, updatedWorkItem: WorkItem): void {
     this.WorkItems[index] = updatedWorkItem;
  }

  deleteWorkItem(id: number): void {
     // find the Work Item in this.workItems using the ID and update it
     const index = this.WorkItems.findIndex(item => item.id === id);
     if (index !== -1) {
        this.WorkItems.splice(index, 1);
     }
  }

   addWorkItem(workItem: WorkItem): void {
      this.WorkItems.push(workItem);
   }

   addPayment(payment: Payment): void {
      this.Payments.push(payment);
   }

}